<script>
import {useStore} from "vuex";
import {ref, watch} from "vue";
import {useRoute} from "vue-router";
import Swals from "@/assets/js/Swals";
import FreeWorld from "@/assets/js/FreeWorld";
import $ from "jquery";
import DatePicker from 'vue3-persian-datetime-picker'
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import axios from "axios";
import LoadingPic from "@/components/assetComponents/LoadingPic.vue";
import persianDate from 'persian-date';
import VideoPage from "@/components/assetComponents/VideoPage.vue";

export default {
  name: "RegisterPage",
  components: {VideoPage, LoadingPic, LoadingPage , DatePicker},
  setup() {

    let store = useStore()
    let states = ref([])
    let cities = ref([])
    let guilds = ref([])
    let loading = ref(false)

    let src_video = ref(store.state.Info.video_register)

    let dialog = ref({
      action:false,
    page: null
    })

    let pics = ref({
      profile:{
        loading:false,
        url:null,
      },
      header:{
        loading:false,
        url:null,
      }
    })

    let cheque = ref(false)

    let data = ref({
      phone: useRoute().params.phone,
      type: 'real',
      name: '',
      prov_id: null,
      city_id: null,
      category_id: null,
      // 'نام شرکت'
      shopname: '',
      // 'کد پستی'
      codepost: '',
      address: '',
      // 'تلفن ثابت'
      telephone: '',
      email: '',
      website: '',
      // 'کد ملی'
      codeid: '',
      // 'تاریخ تولد/تاسیس'
      birthday: null,
      // 'شناسه ملی شرکت'
      company_codeid: '',
      // 'شماره اقتصادی شرکت'
      company_enum: '',
      // 'نام نمایشگاه شرکت'
      company_ename: '',
      // 'تاریخ روزنامه رسمی'
      company_date: '',
      // 'شماره روزنامه رسمی'
      company_number: '',
      // 'نام معرف'
      company_ref_name: '',
      // 'شماره معرف'
      company_ref_phone: '',
      // 'ایمیل معرف'
      company_ref_email: '',
      cheque:0,
      profile_pic: null,
      header_pic: null,
    })


    watch(()=>cheque.value , ()=>{

        let div = document.getElementById('cheque')
        let icon = $("#icon")

      if (cheque.value){
          div.style.height = '15.5rem'
          icon.removeClass('min_rotate_icon').addClass('rotate_icon')
          data.value.cheque = 1
      }else {
        div.style.height = '4.5rem'
        icon.removeClass('rotate_icon').addClass('min_rotate_icon')
        data.value.cheque = 0
      }

    })

    function get_guilds() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'guilds'}, 'info').then((res) => {

        guilds.value = res.data
        data.value.category_id = guilds.value[0].id
        get_country()

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_guilds, true)
      })
    }
    get_guilds()

    function get_country() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'cities'}, 'info').then((res) => {

        loading.value = false
        states.value = res.data
        data.value.prov_id = states.value[0].id
        change_state()

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_country, true)
      })
    }

    function change_state() {

      states.value.forEach((item)=>{
        if (item.id == data.value.prov_id){
          cities.value = item.city
          data.value.city_id = item.city[0].id
        }
      })

    }

    function upload_profile(e) {

      const file = e.target.files[0];
      if (file != undefined) {

        pics.value.profile.loading = true

        axios.post(localStorage.getItem('DOM') + "upload", {
              file: file,
            },
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }).then((res)=>{

          pics.value.profile.loading = false
          if (res.data.status === 'ok') {
            pics.value.profile.url = URL.createObjectURL(file);
            data.value.profile_pic = res.data.name
          }else {
            Swals.Fault('لطفا از فرمت عکس مورد نظر اطمینان حاصل فرمایید!')
          }

        }).catch((res) => {
          pics.value.profile.loading = false
          Swals.Catch(res , ()=>{upload_profile(e)})
        })
      }


    }

    function upload_header(e) {

      const file = e.target.files[0];
      if (file != undefined) {

        pics.value.header.loading = true

        axios.post(localStorage.getItem('DOM') + "upload", {
              file: file,
            },
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }).then((res)=>{

          pics.value.header.loading = false
          if (res.data.status === 'ok') {
            pics.value.header.url = URL.createObjectURL(file);
            data.value.header_pic = res.data.name
          }else {
            Swals.Fault('لطفا از فرمت عکس مورد نظر اطمینان حاصل فرمایید!')
          }

        }).catch((res) => {
          pics.value.header.loading = false
          Swals.Catch(res , ()=>{upload_profile(e)})
        })
      }


    }

    function register() {

      if (data.value.type === 'real' && data.value.name.trim().length === 0) {Swals.Warning('لطفا نام و نام خانوادگی خود را وارد کنید!'); return false}
      if (data.value.type === 'real' && data.value.codeid.trim().length === 0) {Swals.Warning('لطفا کد ملی خود را وارد کنید!'); return false}
      if (data.value.type === 'real' && data.value.address.trim().length === 0) {Swals.Warning('لطفا آدرس فروشگاه خود را وارد کنید!'); return false}
      // if (data.value.type === 'real' && data.value.codepost.trim().length === 0) {Swals.Warning('لطفا کد پستی خود را وارد کنید!'); return false}
      if (data.value.type === 'real' && data.value.shopname.trim().length === 0) {Swals.Warning('لطفا نام فروشگاه خود را وارد کنید!'); return false}

      if (data.value.type === 'legal' && data.value.shopname.trim().length === 0) {Swals.Warning('لطفا نام فروشگاه خود را وارد کنید!'); return false}
      if (data.value.type === 'legal' && data.value.company_enum.trim().length === 0) {Swals.Warning('لطفا شماره اقتصادی شرکت را وارد کنید!'); return false}
      if (data.value.type === 'legal' && data.value.codeid.trim().length === 0) {Swals.Warning('لطفا شماره ملی شرکت را وارد کنید!'); return false}
      if (data.value.type === 'legal' && data.value.codepost.trim().length === 0) {Swals.Warning('لطفا کدپستی شرکت را وارد کنید!'); return false}
      if (data.value.type === 'legal' && data.value.address.trim().length === 0) {Swals.Warning('لطفا آدرس شرکت را وارد کنید!'); return false}
      if (data.value.type === 'legal' && data.value.birthday === null) {Swals.Warning('لطفا تاریخ تاسیس شرکت را وارد کنید!'); return false}

      if (data.value.profile_pic === null) {Swals.Warning('لطفا یک تصویر پروفایل برای خود انتخاب کنید!'); return false}
      if (data.value.header_pic === null) {Swals.Warning('لطفا یک تصویر پروفایل برای خود انتخاب کنید!'); return false}

      let now = new Date();
      let persianNow = new persianDate(now);
      persianNow.formatPersian = false; // تنظیم کردن فرمت اعداد به انگلیسی
      let x = persianNow.format('YYYY/MM/DD');

      if (data.value.type === 'legal' && data.value.birthday > x){
        Swals.Warning('لطفا تاریخ تاسیس شرکت را به صورت صحیح انتخاب کنید! ')
        return false
      }
      if (data.value.type === 'real' && data.value.birthday === x || data.value.birthday > x){
        Swals.Warning('لطفا تاریخ تولد خود را یه صورت صحیح انتخاب کنید! ')
        return false
      }


      loading.value = true
      FreeWorld.Heisenberg(data.value , 'shop/register').then((res)=>{

        loading.value = false
        if (res.data.status == 'ok'){

          dialog.value.action = true
          dialog.value.page = 'alert'

        }else if(res.data.event == 'duplicate phone'){
          Swals.Fault('پروفایل شما قبلا ثبت شده است' , 'LoginPage')
        } else{
          Swals.Fault('متاسفانه ثبت نام شما انجام نشد')
        }

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , register)
      })

    }


    return {

      data,
      states,
      cities,
      guilds,
      change_state,
      register,
      loading,
      cheque,
      upload_profile,
      upload_header,
      pics,
      dialog,
      src_video,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div v-if="dialog.action" class="text-decoration-none bg_dialog"></div>

  <div id="main" :class="loading ? 'activeClass' : '' " class="bg-main">

    <div class="div-top-arrow d-flex align-items-center justify-content-between shadow-custom bg-white">
      <router-link :to="{name:'LoginPage'}" class="d-flex align-items-center">
        <img src="../assets/img/closing_color.svg" alt="" class="svg-arrow">
      </router-link>

      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">ثبت نام</p>
      </div>
    </div>
    <br>
    <br>
    <br>
    <div class="w-100 p-body mt-3 ">

      <div class="shadow-custom bg-white d-flex align-items-center justify-content-start p-2 rounded-pill w-100">
        <img src="../assets/img/info.png" style="height: 35px;width: 35px">
        <p class="mr-1 font-5 font-color text-center">در ابتدا نوع فروشگاه خود را مشخص کنید</p>
      </div>
      <br>
      <div class="shadow-custom rounded-4 overflow-hidden bg-white">

        <div class="d-flex justify-content-between align-items-center w-100">
          <div @click="data.type = 'real'" :class="data.type === 'real' ? 'shadow_select':'' " class="w-50 ml-1 text-center py-2 bg-white rounded-4">
            <img v-if="data.type === 'real'" src="../assets/img/shop2-2.png" style="width: 2.5rem;height: 2.5rem">
            <img v-else src="../assets/img/shop1.png" style="width: 2rem;height: 2rem">
            <p class="font-color font-4 mt-2" :class="data.type === 'real' ? 'font-color font-bold':'font-color_light' ">فروشگاه حقیقی</p>
          </div>

          <div @click="data.type = 'legal'" :class="data.type === 'legal' ? 'shadow_select':'' " class="w-50 mr-1 text-center py-2 bg-white rounded-4">
            <img v-if="data.type === 'legal'" src="../assets/img/shop2.png" style="width: 2.5rem;height: 2.5rem">
            <img v-else src="../assets/img/shop1-1.png" style="width: 2rem;height: 2rem">
            <p class="font-4 mt-2" :class="data.type === 'legal' ? 'font-color font-bold':'font-color_light' ">فروشگاه حقوقی</p>
          </div>
        </div>


        <div v-if="data.type === 'real'" class="p-body mt-5">

        <div class="my-4">
          <p class="m-0 me-2 mb-2 font-4 font-bold font-color">نام و نام خانوادگی مالک فروشگاه*</p>
          <input v-model="data.name" class="shadow-custom bg-white text-center font-4 rounded-4 w-100 p-3" type="text">
        </div>

        <div class="my-4">
          <p class="m-0 me-2 mb-2 font-4 font-bold font-color">کد ملی*</p>
          <input v-model="data.codeid" class="shadow-custom bg-white font-4 text-center rounded-4 w-100 p-3" type="tel" onkeydown="return event.key !== ' '">
        </div>

        <div class="my-4 d-flex justify-content-center align-items-center">
          <div class="w-50">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">استان*</p>
            <select v-model="data.prov_id" @change="change_state" class="text-center w-100 shadow-custom  bg-white p-3 rounded-4">
              <option v-for="item in states" :key="item.id" :value="item.id">{{ item.name }}</option>
            </select>
          </div>
          <div class="w-50 me-2">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">شهر*</p>
            <select v-model="data.city_id" class="text-center w-100 shadow-custom bg-white p-3 rounded-4">
              <option v-for="item in cities" :key="item.id" :value="item.id">{{ item.name }}</option>
            </select>
          </div>
        </div>

        <div class="my-4">
          <p class="m-0 me-2 mb-2 font-4 font-bold font-color">آدرس فروشگاه*</p>
          <textarea style="min-height: 100px;resize: none" v-model="data.address" class="shadow-custom bg-white font-4 rounded-4 w-100 p-3"></textarea>
        </div>

        <div class="my-4">
          <p class="m-0 me-2 mb-2 font-4 font-bold font-color">کد پستی</p>
          <input v-model="data.codepost" class="shadow-custom bg-white text-center font-4 rounded-4 w-100 p-3" type="tel">
        </div>

        <div class="my-4">
          <p class="m-0 me-2 mb-2 font-4 font-bold font-color">ایمیل</p>
          <input v-model="data.email" class="shadow-custom bg-white font-4 text-center rounded-4 w-100 p-3" type="text">
        </div>

        <div class="my-4">
          <p class="m-0 me-2 mb-2 font-4 font-bold font-color">تلفن ثابت</p>
          <input v-model="data.telephone" class="shadow-custom bg-white text-center text-center font-4 rounded-4 w-100 p-3" type="tel" onkeydown="return event.key !== ' '">
        </div>

          <div class="mt-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">تاریخ تولد</p>
            <div class="shadow-custom bg-white font-4 rounded-4 w-100 py-3 px-2 text-center">
              <date-picker class="text-center border-0" v-model="data.birthday"></date-picker>
            </div>
          </div>

        <div class="my-4">
          <p class="m-0 me-2 mb-2 font-4 font-bold font-color">نام فروشگاه*</p>
          <input v-model="data.shopname" class="shadow-custom bg-white text-center font-4 rounded-4 w-100 p-3" type="text">
        </div>

        <div class="my-4">
          <p class="m-0 me-2 mb-2 font-4 font-bold font-color">صنف فعالیت*</p>
          <select v-model="data.category_id" class="text-center bg-white w-100 shadow-custom p-3 rounded-4">
            <option v-for="item in guilds" :key="item.id" :value="item.id">{{ item.name }}</option>
          </select>
        </div>

        <div style="transition: .5s;height: 4.5rem" id="cheque" class="p-body overflow-hidden py-3 rounded-3 shadow-custom bg-white w-100 ">

          <div class="d-flex align-items-center">
              <input v-model="cheque" id="cheque_input" type="checkbox">
          <label for="cheque_input" class="d-flex w-100 justify-content-between align-items-center">
            <div class="d-flex justify-content-center align-items-center">
              <p class="me-2 font-color font-4 font-bold">امکان پرداخت چکی</p>
            </div>
            <img id="icon" src="../assets/img/arrow.png" style="width: 10px;height: 5px">
          </label>
        </div>

          <p class="font-5 text-dark mt-4">درصورت تایید پرداخت با چک، امکان خرید
            چکی برای کاربر فعال میگردد</p>

          <div class="d-flex justify-content-start align-items-start w-100 mt-3 ">
            <div class="d-flex justify-content-start align-items-center w-50">
              <input v-model="data.cheque" :value="1" type="radio" name="cheque">
              <p class="m-0 me-2 font-4">یک ماه</p>
            </div>
            <div class="d-flex justify-content-start align-items-center w-50">
              <input v-model="data.cheque" :value="3" type="radio" name="cheque">
              <p class="m-0 me-2 font-4">حداکثر سه ماه</p>
            </div>
          </div>
          <div class="d-flex justify-content-start align-items-start w-100 mt-3 ">
            <div class="d-flex justify-content-start align-items-center w-50">
              <input v-model="data.cheque" :value="2" type="radio" name="cheque">
              <p class="m-0 me-2 font-4">حداکثر دو ماه</p>
            </div>
            <div class="d-flex justify-content-start align-items-center w-50">
              <input v-model="data.cheque" :value="4" type="radio" name="cheque">
              <p class="m-0 me-2 font-4">حداکثر چهار ماه</p>
            </div>
          </div>
        </div>

        <div class="my-4">
          <p class="me-2 mb-1 font-4 font-bold font-color">تصویر پروفایل*</p>
          <p class="me-2 mb-2 font-5 font-color">300 * 300 پیکسل</p>
          <div class="">
            <input @change="upload_profile" id="profile" style="display: none" type="file">

            <label class="shadow-custom rounded-4 position-relative" style="height: 10rem;width: 10rem" for="profile">
              <img v-if="pics.profile.url !== null" class="w-100 h-100 rounded-4" :src="pics.profile.url">
              <img v-else class="w-100 h-100 rounded-4" src="../assets/img/add_profile.svg">
              <LoadingPic v-if="pics.profile.loading"></LoadingPic>
            </label>
          </div>
        </div>

        <div class="my-4">
          <p class="me-2 mb-1 font-4 font-bold font-color">تصویر سر صفحه*</p>
          <p class="me-2 mb-2 font-5 font-color">800 * 500 پیکسل</p>
          <div class="">
            <input @change="upload_header" id="header" style="display: none" type="file">

            <label class="shadow-custom rounded-4 w-100 position-relative" style="height: 12rem" for="header">
              <img v-if="pics.header.url !== null" class="w-100 h-100 rounded-4" :src="pics.header.url">
              <img v-else class="w-100 h-100 rounded-4" src="../assets/img/add_photo.svg">
              <LoadingPic v-if="pics.header.loading"></LoadingPic>
            </label>
          </div>
        </div>

        <v-btn @click="register" class="py-3 h-100 mb-4 w-100 border-0 rounded-3 bg-color text-white">ثبت نهایی</v-btn>

        </div>

        <div v-if="data.type === 'legal'" class="p-body mt-5">

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">نام شرکت*</p>
            <input v-model="data.shopname" class="shadow-custom bg-white font-4 text-center rounded-4 w-100 p-3 text-center" type="text" placeholder="فروشگاه شما در اپلیکیشن با این نام نمایش داده میشود">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">شماره اقتصادی شرکت*</p>
            <input v-model="data.company_enum" class="shadow-custom bg-white text-center font-4 rounded-4 w-100 p-3 text-center" type="text">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">شناسه ملی شرکت*</p>
            <input v-model="data.codeid" class="shadow-custom bg-white font-4 text-center rounded-4 w-100 p-3 text-center" type="text">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">کد پستی شرکت*</p>
            <input v-model="data.codepost" class="shadow-custom bg-white font-4 text-center rounded-4 w-100 p-3" type="text">
          </div>

          <div class="my-4 d-flex justify-content-center align-items-center">
            <div class="w-50">
              <p class="m-0 me-2 mb-2 font-4 font-bold font-color">استان*</p>
              <select v-model="data.prov_id" class="text-center w-100 shadow-custom bg-white p-3 rounded-4">
                <option v-for="item in states" :key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
            </div>
            <div class="w-50 me-2">
              <p class="m-0 me-2 mb-2 font-4 font-bold font-color">شهر*</p>
              <select v-model="data.city_id" class="text-center w-100 shadow-custom bg-white p-3 rounded-4">
                <option v-for="item in cities" :key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
            </div>
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">آدرس شرکت / فروشگاه*</p>
            <textarea style="min-height: 100px;resize: none" v-model="data.address" class="shadow-custom bg-white font-4 rounded-4 w-100 p-3"></textarea>
          </div>


          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">تلفن ثابت</p>
            <input v-model="data.telephone" class="shadow-custom bg-white font-4 text-center rounded-4 w-100 p-3" type="tel" onkeydown="return event.key !== ' '">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">ایمیل</p>
            <input v-model="data.email" class="shadow-custom bg-white font-4 text-center rounded-4 w-100 p-3" type="text">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">وب سایت</p>
            <input v-model="data.website" class="shadow-custom bg-white font-4 text-center rounded-4 w-100 p-3" type="text">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">نام نمایشگاه شرکت</p>
            <input v-model="data.company_ename" class="shadow-custom bg-white text-center font-4 rounded-4 w-100 p-3" type="Text">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">دسته بندی فعالیت*</p>
            <select v-model="data.category_id" class="text-center bg-white w-100 shadow-custom p-3 rounded-4">
              <option v-for="item in guilds" :key="item.id" :value="item.id">{{ item.name }}</option>
            </select>
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">شماره روزنامه رسمی</p>
            <input v-model="data.company_number" class="shadow-custom bg-white text-center font-4 rounded-4 w-100 py-3 px-2" type="text">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">تاریخ روزنامه رسمی</p>
            <input v-model="data.company_date" class="shadow-custom bg-white text-center font-4 rounded-4 w-100 p-3" type="text">
          </div>

          <div class="mt-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">تاریخ تاسیس *</p>
            <div class="shadow-custom bg-white font-4 rounded-4 w-100 py-3 px-2 text-center">
              <date-picker class="text-center border-0" v-model="data.birthday"></date-picker>
            </div>
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">نام مدیر عامل</p>
            <input v-model="data.name" class="shadow-custom text-center bg-white font-4 rounded-4 w-100 p-3" type="text">
          </div>

          <p class="m-0 me-2 mb-2 font-3 font-bold font-color">نماینده معرفی شده</p>
          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">نام و نام خانوادگی</p>
            <input v-model="data.company_ref_name" class="shadow-custom text-center bg-white font-4 rounded-4 w-100 p-3" type="text">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">شماره موبایل</p>
            <input v-model="data.company_ref_phone" class="shadow-custom text-center bg-white font-4 rounded-4 w-100 p-3" maxlength="11" type="tel" onkeydown="return event.key !== ' '">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">ایمیل</p>
            <input v-model="data.company_ref_email" class="shadow-custom text-center bg-white font-4 rounded-4 w-100 p-3" type="text">
          </div>

          <div class="my-4">
            <p class="me-2 mb-1 font-4 font-bold font-color">تصویر پروفایل*</p>
            <p class="me-2 mb-2 font-5 font-color">300 * 300 پیکسل</p>
            <div class="">
              <input @change="upload_profile" id="profile" style="display: none" type="file">

              <label class="shadow-custom rounded-4 position-relative" style="height: 10rem; width: 10rem" for="profile">
                <img v-if="pics.profile.url !== null" class="w-100 h-100 rounded-4" :src="pics.profile.url">
                <img v-else class="w-100 h-100 rounded-4" src="../assets/img/add_profile.svg">
                <LoadingPic v-if="pics.profile.loading"></LoadingPic>
              </label>
            </div>
          </div>

          <div class="my-4">
            <p class="me-2 mb-1 font-4 font-bold font-color">تصویر سر صفحه*</p>
            <p class="me-2 mb-2 font-5 font-color">800 * 500 پیکسل</p>
            <div class="">
              <input @change="upload_header" id="header" style="display: none" type="file">

              <label class="shadow-custom rounded-4 w-100 position-relative" style="height: 12rem" for="header">
                <img v-if="pics.header.url !== null" class="w-100 h-100 rounded-4" :src="pics.header.url">
                <img v-else class="w-100 h-100 rounded-4" src="../assets/img/add_photo.svg">
                <LoadingPic v-if="pics.header.loading"></LoadingPic>
              </label>
            </div>
          </div>

          <v-btn @click="register" class="py-3 h-100 mb-4 w-100 border-0 rounded-3 bg-color text-white">ثبت نهایی</v-btn>

        </div>

      </div>
    </div>
    <br>
    <br>

    <div v-if="dialog.page === 'alert'" class="dialog max_width p-body">
      <div class="bg-white rounded-4">

        <div style="height: 45px"
             class="bg-color d-flex justify-content-center align-items-center rounded-top-4 text-center position-relative">
          <img style="height: 10vh;left: 0" class="position-absolute bottom-0"
               src="../assets/img/icon_done_dialog.svg" alt="">
          <p class="text-white font-4">تایید ثبت نام</p>
        </div>

        <div class="p-5">
          <p class="font-4 text-center">ثبت نام شما با موفقیت انجام شد برای استفاده از اپلیکیشن منتظر تایید مدیریت باشید</p>
          <p @click="dialog.page = 'video'" class="font-4 mt-4 font-color-red text-center">لطفا ویدئو آموزشی ما را ببینید</p>
        </div>
      </div>
    </div>

    <VideoPage v-if="dialog.page === 'video'" :src="src_video"></VideoPage>

  </div>

</template>

<style scoped>

.rotate_icon {
  transform: rotate(180deg);
  transition: .5s;
}

.min_rotate_icon {
  transform: rotate(0deg);
  transition: .5s;
}

.shadow_select {
  box-shadow: 0 -10px 10px -2px #707070;
}

</style>